// @ts-ignore
import { createAppCache } from '@whys/appcache';
import { RuntimeAppCache } from '../app.types/state';

export function createRuntimeCache(): RuntimeAppCache {
  return createAppCache();
}
